import { render, staticRenderFns } from "./Partners_Ntanasi.vue?vue&type=template&id=6e2bab86&scoped=true"
import script from "./Partners_Ntanasi.vue?vue&type=script&lang=js"
export * from "./Partners_Ntanasi.vue?vue&type=script&lang=js"
import style0 from "./Partners_Ntanasi.vue?vue&type=style&index=0&id=6e2bab86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2bab86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
